import { render, staticRenderFns } from "./MyAccountLayout.vue?vue&type=template&id=0ad5c4da&scoped=true"
import script from "./MyAccountLayout.vue?vue&type=script&lang=js"
export * from "./MyAccountLayout.vue?vue&type=script&lang=js"
import style0 from "./MyAccountLayout.vue?vue&type=style&index=0&id=0ad5c4da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad5c4da",
  null
  
)

export default component.exports